<template>
  <div>
<Layout>
  <div>
    <b-overlay :show="show" rounded="sm">
  <b-row>
    <b-col md="4">
      <b-container>
        <b-card>
          <b-row>
            <b-col v-for="(question, nIndex) in test.test.questions"
               md="3" :key="nIndex"
               class="p-2"
                >
              <div class="w-75">
                <b-button variant="outline-secondary" class="w-100" :class="question.answer ? 'bg-warning text-white' : ''"
                          size="lg" @click="goToWithId(question.id)">{{nIndex + 1}}</b-button>
              </div>
            </b-col>
          </b-row>
          <hr>
          <h3>{{$t('message.All_questions')}}: {{test.test ? test.test.questions.length : 0}}</h3>
          <h3 class="mt-2">{{$t('message.Given_time')}}: {{test.test ? test.test.time : '00:00'}}</h3>
          <div class="text-center mt-4">
            <h3 class="text-primary">{{time}}</h3>
          </div>
        </b-card>
        <div class="text-center">
          <b-button
              class="btn"
              variant="outline-primary"
              @click="finishTest"
          > {{$t('message.Finish_test')}}
          </b-button>
        </div>
      </b-container>
    </b-col>
    <b-col md="8">
      <b-container>
        <b-card class="d-flex">
<!--          <header class="header">-->
<!--          <h4-->
<!--          >Ingliz tili bo'yicha test savollari-->
<!--          </h4>-->
<!--        </header>-->
        <Questions :questions.sync="test.test.questions" :goToId="goToId" @answerSelected="answerSelected" />
        </b-card>
      </b-container>
      <b-button
          class="btn ms-5"
          variant="outline-primary"
          @click="finishTest"
      > {{$t('message.Finish_test')}}
      </b-button>
    </b-col>
  </b-row>
    </b-overlay>
  </div>
</Layout>
  </div>
</template>

<script>

import Layout from "../../../../layouts/main";
import Questions from "./Questions";
import {getApplicationTest, getFinishTest, saveRemainingTime,saveUserAnswers} from "../../../../../api/tests";
import Swal from "sweetalert2";

export default {
  name: "Test",
  components:{
    Questions,
    Layout
  },
  data() {
    return {
      test:[],
      goToId: null,
      time: '00:00',
      interval: {
        hour:0,
        minutes: 0,
        seconds: 0
      },
      timeInterval: null,
      show: false,
      shouldSaveTime: false,
    }
  },
  created() {
    this.fetchTestQuestions()
  },
  methods: {
    fetchTestQuestions() {
      getApplicationTest(this.$route.params).then(res => {
        if(res.data.data === 'not_active') {
          this.$router.push({name: "personalinformation"})
        }
        else {
          this.test = res.data.data;
          this.time = this.test.remaining_time ? this.test.remaining_time : res.data.data.test.time;
          this.startInterval()
        }
      })
    },
    goToWithId(id) {
      this.goToId = id;
    },
    setRemainingTime(time) {
      saveRemainingTime({test_id: this.test.id,time})
      this.shouldSaveTime = false
    },
    answerSelected() {
      let questionAnswerForm = this.test.test.questions.map(item => Object.assign({}, {question_id: item.id,answer: item.answer}))
      saveUserAnswers({test_id: this.test.id, question_answers: questionAnswerForm,time: this.time});
    },
    finishTest(){
      Swal.fire({
        title: this.$t('message.Are_you_sure'),
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.Finish_test'),
        cancelButtonText:this.$t('message.Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          this.show = true
          let questionAnswerForm = this.test.test.questions.map(item => Object.assign({}, {question_id: item.id,answer: item.answer}))
          getFinishTest({questions: questionAnswerForm, test_id:this.test.id}).then(() => {
            this.show = false;
            clearInterval(this.timeInterval)
            this.$router.push({name: "personalinformation"});
          })
        } else if (result.dismiss === 'cancel') {
          Swal.fire({
            title: this.$t('message.Cancelled'),
            text: '',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    timeIsOver() {
      let questionAnswerForm = this.test.test.questions.map(item => Object.assign({}, {question_id: item.id,answer: item.answer}))
      getFinishTest({questions: questionAnswerForm, test_id:this.test.id}).then(() => {
        this.show = false;
        clearInterval(this.timeInterval)
        this.$router.push({name: "personalinformation"});
      })
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: this.$t('TimeIsOver'),
        showConfirmButton: false,
        timer: 1500
      })

      setTimeout(() => {
        this.$router.push('/')
      },1500)
    },
    startInterval() {
      let split = this.time.split(":");
      this.interval.hour = parseInt(split[0]);
      this.interval.minutes = parseInt(split[1]);
      this.interval.seconds = parseInt(split[2]);

      if(this.interval.seconds === 0) {
        if(this.interval.minutes > 0) {
          this.interval.seconds = 59;
          this.interval.minutes--;
        }
        else {
          if(this.interval.hour > 0) {
            this.interval.minutes = 59;
            this.interval.hour--;
          }
        }
      }
      this.timeInterval = setInterval(() => {
        if(this.interval.hour === 0 && this.interval.minutes === 0 && this.interval.seconds === 0) {
          this.timeIsOver()
        }
        if(this.interval.seconds > 0) {
          this.interval.seconds--;
        }
        else if(this.interval.seconds === 0) {
          if(this.interval.minutes > 0) {
            this.interval.seconds = 59;
            this.interval.minutes--;
            this.shouldSaveTime = true;
          }
          else if(this.interval.minutes === 0) {
            if(this.interval.hour > 0) {
              this.interval.minutes = 59;
              this.interval.seconds = 59;
              this.interval.hour--;
            }

          }
        }
        this.time = (this.interval.hour < 10 ? `0${this.interval.hour}` : this.interval.hour)+":"+
            (this.interval.minutes < 10 ? `0${this.interval.minutes}` : this.interval.minutes)+":"+
            (this.interval.seconds < 10 ? `0${this.interval.seconds}` : this.interval.seconds);
        if(this.interval.seconds === 59) {
          this.setRemainingTime(this.time);
        }
      },1000)
    }
  },
}
</script>

<style scoped>
.header{
  background-color: #4d63cf;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px
}
h4{
  text-align: center;
  color: #ffffff;
}
</style>
